export default __webpack_public_path__ + "static/media/squigly-globe.534e2373.png";